import React, { PureComponent } from "react";
import { ResponsiveContainer, AreaChart, Area, Legend, Tooltip, XAxis, YAxis } from "recharts";

function generateArray(n) {
  return [...Array(n + 1).keys()];
}

const TIME_PERIOD_VALUES = {
  Month: {
    unit: "Day",
    values: generateArray(30)
  },
  Day: {
    unit: "Hour",
    values: generateArray(24)
  },
  Week: {
    unit: "Day",
    values: generateArray(7)
  },
  Quarter: {
    unit: "Week",
    values: generateArray(14)
  },
  Year: {
    unit: "Month",
    values: generateArray(12)
  }
};

export default class LineChart extends PureComponent {
  render() {
    const { scenarios, selectedScenario, hoverScenario, deployedIndex, timePeriod } = this.props;

    const timePeriodValue = TIME_PERIOD_VALUES[timePeriod] || TIME_PERIOD_VALUES.MONTH;

    const { unit, values } = timePeriodValue;

    let data = values.map((t) => ({
      name: unit + " " + t,
      multiplier: t / (values.length - 1)
    }));

    const filteredScenarios = scenarios.filter((s, i) => {
      if (!s.originalScenario) {
        return false;
      }
      if (deployedIndex !== undefined && s.index !== deployedIndex) {
        return false;
      }
      return true;
    });

    data.forEach((d) => {
      filteredScenarios.forEach((s, i) => {
        d["(" + i + ") " + (s.originalScenario ? s.originalScenario.name : "")] = Number(
          (s.profit * d.multiplier).toFixed(2)
        );
      });
    });

    const sortedScenarios = filteredScenarios.sort((a, b) => b.profit - a.profit);

    const bestScenario = sortedScenarios.length > 1 ? sortedScenarios[0] : undefined;
    const worstScenario = sortedScenarios.length > 1 ? sortedScenarios[sortedScenarios.length - 1] : undefined;

    return (
      <ResponsiveContainer>
        <AreaChart data={data} margin={{ top: 20, left: 20, right: 40, bottom: 20 }}>
          <defs>
            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#E6E6FC" stopOpacity={1.0} />
              <stop offset="95%" stopColor="#E6E6FC" stopOpacity={0.3} />
            </linearGradient>
          </defs>
          <XAxis dataKey="name" />
          <YAxis />
          {filteredScenarios.map((s, i) => (
            <Area
              key={i}
              type="monotone"
              dataKey={"(" + i + ") " + (s.originalScenario ? s.originalScenario.name : "")}
              strokeWidth={
                (hoverScenario && s.originalScenario && s.originalScenario.id === hoverScenario) ||
                (hoverScenario === undefined &&
                  s.originalScenario &&
                  selectedScenario &&
                  selectedScenario.originalScenario &&
                  s.originalScenario.id === selectedScenario.originalScenario.id)
                  ? 3
                  : 2
              }
              stroke={
                hoverScenario && s.originalScenario.id === hoverScenario
                  ? "#512F77"
                  : s.index === deployedIndex ||
                      (s.originalScenario &&
                        selectedScenario &&
                        selectedScenario.originalScenario &&
                        s.originalScenario.id === selectedScenario.originalScenario.id)
                    ? "#F47C20"
                    : bestScenario &&
                        s.originalScenario &&
                        bestScenario.originalScenario &&
                        s.originalScenario.id === bestScenario.originalScenario.id
                      ? "#54C06C"
                      : worstScenario &&
                          s.originalScenario &&
                          worstScenario.originalScenario &&
                          s.originalScenario.id === worstScenario.originalScenario.id
                        ? "#C03E5A"
                        : "rgba(134, 133, 148, 1)"
              }
              fillOpacity={1}
              fill={
                bestScenario &&
                s.originalScenario &&
                bestScenario.originalScenario &&
                s.originalScenario.id === bestScenario.originalScenario.id
                  ? "url(#colorUv)"
                  : "transparent"
              }
            />
          ))}
          <Legend />
          <Tooltip />
        </AreaChart>
      </ResponsiveContainer>
    );
  }
}
